import React from 'react';
import { profile } from '../data/profile';
import './contact.css';

export default function Contact() {
  return <section className="contact section-shell" id="contact" aria-labelledby="contact-title">
    <div className="contact__top" data-reveal><span className="eyebrow">HAVE SOMETHING IN MIND?</span><span className="contact__star" aria-hidden="true">✳︎</span></div>
    <h2 id="contact-title" tabIndex="-1" data-reveal>Let's make<br /><em>something matter.</em></h2>
    <div className="contact__bottom" data-reveal><p>A product, a visual world, or an idea<br />that needs a little direction. Let's talk.</p>
      <div className="contact__actions"><a className="pill-link pill-link--light" href={`mailto:${profile.email}`}>Email me <span aria-hidden="true">↗︎</span></a><a className="pill-link" href={profile.linkedin} target="_blank" rel="noreferrer">Let's connect on LinkedIn <span aria-hidden="true">↗︎</span></a></div>
    </div>
  </section>;
}
